import { httpRequest } from "../../http";
import { CatalogDimension } from "@models/catalog.model";

export class CommandListDimensions {
  // A vertical's tracking axes, each with the concrete values observed in the data.
  async run(verticalCode: string): Promise<CatalogDimension[]> {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/catalog/verticals/${encodeURIComponent(verticalCode)}/dimensions/`;
    return httpRequest<CatalogDimension[]>(url, { method: "GET" });
  }
}
